// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1cvcF","title":"AfterBackImages_title__Biwj1","images":"AfterBackImages_images__1QLRG"};